import React, { useContext, useState } from 'react'
import api from '../../utils/api'
import { CaseDetailContext } from './CaseDetailContext'

/**
 * CaseCancel — port of Scale's CaseCancel.jsx ("Take off Calendar").
 * Soft-cancels the case: parties are notified, documents retained,
 * future notifications stopped. Reschedulable later.
 */
export default function CaseCancel({ onToast, onCancelled }) {
    const { caseData, is_cancled_case } = useContext(CaseDetailContext)
    const [dialogIsOpen, setDialogIsOpen] = useState(false)
    const [loading, setLoading] = useState(false)

    const handleCancel = async () => {
        if (!caseData?.id) return
        try {
            setLoading(true)
            await api.post(`/cases/${caseData.id}/cancel`)
            setDialogIsOpen(false)
            setLoading(false)
            onToast?.({ type: 'success', message: 'Case cancelled successfully' })
            if (onCancelled) onCancelled()
            else setTimeout(() => window.location.reload(), 1500)
        } catch (err) {
            setLoading(false)
            console.error('Failed to cancel case:', err)
            onToast?.({ type: 'error', message: 'Failed to cancel case' })
        }
    }

    return (
        <div className="w-full m-0 p-0 h-full flex items-stretch">
            <button
                type="button"
                onClick={() => !is_cancled_case && setDialogIsOpen(true)}
                disabled={is_cancled_case}
                title={is_cancled_case ? 'Case is already canceled!' : ''}
                className={`bg-white border border-gray-300 text-gray-600 rounded-md h-11 px-4 py-2 flex justify-between items-center w-full transition-colors ${is_cancled_case ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:bg-gray-50'}`}
            >
                <span className="text-sm font-medium">Take off Calendar</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5 flex-shrink-0 text-gray-500">
                    <path d="M18.364 5.636a1 1 0 0 0-1.414 0L12 10.586 7.05 5.636a1 1 0 0 0-1.414 1.414L10.586 12l-4.95 4.95a1 1 0 1 0 1.414 1.414L12 13.414l4.95 4.95a1 1 0 0 0 1.414-1.414L13.414 12l4.95-4.95a1 1 0 0 0 0-1.414z"/>
                </svg>
            </button>

            {dialogIsOpen && (
                <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50" onClick={() => !loading && setDialogIsOpen(false)}>
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 p-6" onClick={(e) => e.stopPropagation()}>
                        <div className="border-b pb-2"><h5 className="text-lg font-semibold mb-1">Take off Calendar</h5></div>
                        <p className="text-gray-900 font-semibold text-md mt-4">
                            Parties will receive an email confirming that the mediation has been removed from the calendar.
                            All case documents will remain in the system, allowing you to reschedule at any time and add
                            participants to the CRM as needed. Future notifications related to this mediation will be stopped.
                        </p>
                        <div className="w-full flex justify-between gap-3 mt-6">
                            <button type="button" disabled={loading} className="w-full bg-[#EBEBEB] text-black font-semibold rounded-xl py-3" onClick={() => setDialogIsOpen(false)}>No</button>
                            <button type="button" disabled={loading} onClick={handleCancel} className="w-full bg-[#FC4043] text-white rounded-xl py-3 font-semibold disabled:opacity-60">
                                {loading ? 'Cancelling…' : 'Yes'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
